import { UploadFormView } from "./UploadForm.view";
import { useUploadForm } from "./useUploadForm";
import type { UploadFormProps } from "./UploadForm.types";

/**
 * Collects both workbooks and the run settings, then starts a reconciliation.
 *
 * @example
 * <UploadForm defaults={config.defaults} receiptSource={config.receipt_source}
 *   isRunning={false} error={null} isSessionExpired={false}
 *   onSubmit={run} onReauthenticate={reload} />
 */
export function UploadForm(props: UploadFormProps) {
  const form = useUploadForm({ defaults: props.defaults, onSubmit: props.onSubmit });

  return (
    <UploadFormView
      {...props}
      wcReport={form.wcReport}
      wcSource={form.wcSource}
      opsMaster={form.opsMaster}
      landingRate={form.landingRate}
      lookbackDays={form.lookbackDays}
      rateError={form.rateError}
      lookbackError={form.lookbackError}
      canSubmit={form.canSubmit}
      bands={form.bands}
      bbWcRateFallback={form.bbWcRateFallback}
      bbWcRateAlways={form.bbWcRateAlways}
      bbWcLandingRate={form.bbWcLandingRate}
      bbWcLandingRateError={form.bbWcLandingRateError}
      bbWcBands={form.bbWcBands}
      bbWcCustomsFallback={form.bbWcCustomsFallback}
      bbWcCustomsAlways={form.bbWcCustomsAlways}
      bbWcCustomsRate={form.bbWcCustomsRate}
      bbWcCustomsRateError={form.bbWcCustomsRateError}
      onWcReport={form.setWcReport}
      onWcSource={form.setWcSource}
      onOpsMaster={form.setOpsMaster}
      onClearWcReport={form.clearWcReport}
      onClearOpsMaster={form.clearOpsMaster}
      onLandingRate={form.setLandingRate}
      onLookbackDays={form.setLookbackDays}
      onBbWcRateFallback={form.setBbWcRateFallback}
      onBbWcRateAlways={form.setBbWcRateAlways}
      onBbWcLandingRate={form.setBbWcLandingRate}
      onBbWcCustomsFallback={form.setBbWcCustomsFallback}
      onBbWcCustomsAlways={form.setBbWcCustomsAlways}
      onBbWcCustomsRate={form.setBbWcCustomsRate}
      onRun={form.submit}
    />
  );
}
